import { gql } from '@apollo/client'
import employeeDisplayTinyInfoFragment from '../../employee/fragments/employeeDisplayTinyInfo.fragment'

export default gql`
  fragment EmployeeTagInfo on EmployeeTagInfo {
    id
    addedDate
    removedDate
    type
    note
    employee {
      ...EmployeeDisplayTinyInfo
    }
    addedBy {
      ...EmployeeDisplayTinyInfo
    }
    removedBy {
      ...EmployeeDisplayTinyInfo
    }
  }

  ${employeeDisplayTinyInfoFragment}
`
